const fb = require('../firebase.js');
class Profile {
    constructor(id) {
        this.id = id
    }
    async updateProfile() {
        const profile = await fb.db.collection("profiles").doc(this.id);
        const idMemo = this.id
        delete this.id
        await profile.update({ ...this });
        this.id = idMemo
    }

    async getProfile() {
        const doc = await fb.db.collection("profiles").doc(this.id).get();
        this.id = doc.id
        this.firstName = doc.data().firstName
        this.fullAddress = doc.data().fullAddress
        this.lastName = doc.data().lastName
        this.mail = doc.data().mail
        this.tel = doc.data().tel
    }

    profileIsComplete(){
            return (this.firstName &&
                    this.lastName &&
                    this.tel &&
                    this.fullAddress.postalCode &&
                    this.fullAddress.country &&
                    this.fullAddress.city &&
                    this.fullAddress.address) ? true : false
    }
}

module.exports = { Profile };